import { render, staticRenderFns } from "./MultipleAssignmentPopup.vue?vue&type=template&id=466a87b5&scoped=true&"
import script from "./MultipleAssignmentPopup.vue?vue&type=script&lang=js&"
export * from "./MultipleAssignmentPopup.vue?vue&type=script&lang=js&"
import style0 from "./MultipleAssignmentPopup.vue?vue&type=style&index=0&id=466a87b5&lang=scss&scoped=true&"
import style1 from "./MultipleAssignmentPopup.vue?vue&type=style&index=1&id=466a87b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466a87b5",
  null
  
)

export default component.exports